import { CallLogs } from '@/features/customers/components/CallLogs';
import { CustomerContext } from '@/features/customers/contexts/CustomerContext';
import { LocationContext } from '@/providers/location';
import { useContext } from 'react';

export const CallsTab = () => {
  const { customer } = useContext(CustomerContext);
  const { activeLocationId } = useContext(LocationContext);

  if (null === activeLocationId) return <>No active location found.</>;

  if (!customer) return <>No customer found.</>;

  return <CallLogs customer={customer} location={activeLocationId} />;
};
